import { schema } from "normalizr";
import { AccountCarrier } from "./account-carrier";

export const AccountCarriers = new schema.Array(AccountCarrier);
